module.exports = __webpack_public_path__ + "static/media/movement-speed.b828d547.png";